import { render, staticRenderFns } from "./FormPage2.vue?vue&type=template&id=103468f1&"
import script from "./FormPage2.vue?vue&type=script&lang=js&"
export * from "./FormPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports